import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { NavBar } from './components/NavBar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { MetodoPage } from './pages/MetodoPage';
import { SesionesPage } from './pages/SesionesPage';
import { SobreLauraPage } from './pages/SobreLauraPage';
import { PreguntasPage } from './pages/PreguntasPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen w-full bg-white selection:bg-teal selection:text-white" data-id="element-2">
        <NavBar data-id="element-3" />
        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/metodo" element={<MetodoPage data-id="element-9" />} data-id="element-8" />
            <Route path="/sesiones" element={<SesionesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/sobre-laura" element={<SobreLauraPage data-id="element-13" />} data-id="element-12" />
            <Route path="/preguntas" element={<PreguntasPage data-id="element-15" />} data-id="element-14" />
            <Route path="*" element={<HomePage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <Footer data-id="element-18" />
      </div>
    </BrowserRouter>;
}